import { EnhancedDimension } from '@factorialco/deprecated-design-system'
import { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import EmployeeSelectorInput from 'modules/core/components/Inputs/EmployeeSelector'
import i18n from 'modules/core/lib/i18n'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type EmployeeModel from 'modules/employees/store/models/Employee'

type IdsTypes = number[] | (number | null | undefined)

interface Props {
  field: Field
  hideLabel?: boolean
  onSelectEmployee: (ids: IdsTypes) => void
  selectedEmployeeIds: number[]
  selectableEmployees: EmployeeModel[]
  error?: string
  width?: EnhancedDimension | null
  contractVersions: ContractVersions
}

const EmployeesSelector = ({
  field,
  hideLabel,
  onSelectEmployee,
  selectedEmployeeIds,
  selectableEmployees,
  width = null,
  contractVersions,
}: Props) => {
  return (
    <EmployeeSelectorInput
      hasSubmitButton
      isMultiSelect
      attachment="top center"
      field={field}
      label={hideLabel ? '' : i18n.t('shift_management.no_selection_form.assign_to')}
      employees={selectableEmployees}
      onSelectEmployee={onSelectEmployee}
      selectedEmployeeIds={selectedEmployeeIds}
      virtualized
      multiFilters
      width={width}
      contractVersions={contractVersions}
    />
  )
}

export default observer(EmployeesSelector)
